module.exports = __webpack_public_path__ + "static/media/img3-1.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/limon/nutricheck_foliar/ZN/img3-1.png
// module id = 1688
// module chunks = 3